/**
 * 注册页：邮箱+密码+昵称；注册成功自动登录并进入首页。
 */
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../stores/auth';
import { Button, Card, ErrorBox, Field, Input, errMsg } from '../components/ui';
import { Icon } from '../components/icons';

export function RegisterPage() {
  const navigate = useNavigate();
  const register = useAuth((s) => s.register);
  const [email, setEmail] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!email.trim() || !displayName.trim() || !password) {
      setError('请填写所有必填项');
      return;
    }
    if (password.length < 10 || !/[A-Za-z]/.test(password) || !/[0-9]/.test(password)) {
      setError('密码至少 10 位，且包含字母和数字');
      return;
    }
    if (password !== confirm) {
      setError('两次输入的密码不一致');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await register({ email: email.trim(), password, displayName: displayName.trim() });
      navigate('/', { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 dark:bg-slate-950">
      <div className="w-full max-w-sm">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-600 text-white">
            <Icon name="sun" className="h-8 w-8" />
          </div>
          <h1 className="text-2xl font-semibold">创建帐号</h1>
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">开始你的追光之旅</p>
        </div>
        <Card className="p-6">
          <form onSubmit={submit} className="space-y-4">
            <ErrorBox error={error} />
            <Field label="邮箱" required>
              <Input type="email" autoFocus autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
            </Field>
            <Field label="昵称" required>
              <Input value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
            </Field>
            <Field label="密码" required hint="至少 10 位，含字母和数字">
              <Input
                type="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Field>
            <Field label="确认密码" required>
              <Input
                type="password"
                autoComplete="new-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
              />
            </Field>
            <Button type="submit" className="w-full" loading={busy}>
              注册
            </Button>
          </form>
          <p className="mt-4 text-center text-sm text-slate-500 dark:text-slate-400">
            已有帐号？
            <Link to="/login" className="ml-1 font-medium text-indigo-600 hover:underline dark:text-indigo-400">
              登录
            </Link>
          </p>
        </Card>
      </div>
    </div>
  );
}
